// TODO: Rename this file

type PrimitiveValue = boolean | number | string | null;
const SUPPORTED_FLAG_TYPES = ['boolean', 'number', 'string', 'object'] as const;

export type SupportedFlagType = (typeof SUPPORTED_FLAG_TYPES)[number];

export function coerceFlagValue(
  value: string | undefined,
  type: SupportedFlagType,
): PrimitiveValue {
  switch (type) {
    case 'boolean':
      return value === 'true';
    case 'number':
      return Number(value);
    case 'string':
      return String(value);
    default:
      return null;
  }
}

export function isSupportedFlagType(type: string): type is SupportedFlagType {
  return SUPPORTED_FLAG_TYPES.includes(type as SupportedFlagType);
}
